export default function Crosshair({ style, color = 'var(--accent)', stroke = 3 }) {
  return (
    <svg viewBox="0 0 100 100" style={style} filter="drop-shadow(0 0 4px rgba(225, 19, 23, 0.6))">
      <g stroke={color} strokeWidth={stroke} strokeLinecap="round" fill="none">
        <line x1="50" y1="8" x2="50" y2="32" />
        <line x1="50" y1="68" x2="50" y2="92" />
        <line x1="8" y1="50" x2="32" y2="50" />
        <line x1="68" y1="50" x2="92" y2="50" />
        <circle cx="50" cy="50" r="3.5" fill={color} stroke="none" />
      </g>
    </svg>
  );
}
